import React from 'react'
import { CopertinaBox as OriginalCopertinaBox } from '@next-nx/shared-ui/organisms'
import { CopertinaBoxSettings } from './CopertinaBoxSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { useEditor } from '@craftjs/core'

export const defaultProps = {
  image: '',
  src: 'https://via.placeholder.com/960x414.png',
  imagePos: 'right',
  ctaLabel: '',
  pageLink: '',
  link: '',
  openNewTab: false,
}

export const CopertinaBox = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    };

    const { imagePos, image, src, ctaLabel, pageLink, link, openNewTab } = blockProps

    const { children } = props
    
    const { enabled } = useEditor((state) => ({
      enabled: state.options.enabled,
    }));

    return (
      <div
        ref={(ref) => props.retRef(ref)}
        className={'block-copertina-box ' + props.className}
      >
        <OriginalCopertinaBox
          key={image ? image : src}
          item={{
            name: children.props.children[0],
            description: children.props.children[1],
            image: image ? image : src,
            ctaLabel: ctaLabel,
            url: pageLink || link || '#',
            blank: openNewTab
          }}
          imagePos={imagePos}
          editMode={enabled}
        />
      </div>
    );
  },
  defaultProps
);

CopertinaBox.craft = withCraft({
  name: 'CopertinaBox',
  defaultProps: defaultProps,
  settings: CopertinaBoxSettings,
});
